import API from 'js/lib/api';

export default API('/api/subscriptions.v1', {
  type: 'rest',
});
